import { createFileRoute } from "@tanstack/react-router";

import { AdminDecks } from "@/features/admin";

/**
 * Admin · Presentazioni — the list of Ando Lab presentations and, with
 * ``?p=<slug>``, the editor of one (versions, links, Ando). Gated by the Admin
 * shell (``isPlatformAdmin``); every BE endpoint enforces ``require_platform_admin``.
 */
export const Route = createFileRoute("/_authed/_modal/admin/presentazioni")({
  validateSearch: (search: Record<string, unknown>): { p?: string } => ({
    p: typeof search.p === "string" && /^[a-z0-9][a-z0-9-]{0,39}$/.test(search.p) ? search.p : undefined,
  }),
  component: AdminDecks,
});
